import React from 'react';

const Footer = () => {
    return (
        <footer className="global-footer">
            <p>&copy; {new Date().getFullYear()} The Plastic Waste Band. All Rights Reserved.</p>
        </footer>
    );
}

export default Footer;